package dev.terrakok.mapitan.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import dev.terrakok.mapitan.domain.DocumentObject
import dev.terrakok.mapitan.domain.LineStyle
import dev.terrakok.mapitan.domain.Area
import dev.terrakok.mapitan.domain.Label
import dev.terrakok.mapitan.domain.Track
import dev.terrakok.mapitan.ui.Icons

@Composable
fun EditorOptions(
    editorMode: Mode,
    color: Color,
    onColorSelected: (Color) -> Unit,
    lineThickness: Int,
    onLineThicknessSelected: (Int) -> Unit,
    lineStyle: LineStyle,
    onLineStyleSelected: (LineStyle) -> Unit,
    labelText: String,
    selectedObject: DocumentObject?,
    onLabelTextChanged: (String) -> Unit,
    onRemoveSelectedObject: () -> Unit,
    modifier: Modifier = Modifier
) {
    if (editorMode == Mode.Cursor && selectedObject == null) return
    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
        elevation = CardDefaults.cardElevation(defaultElevation = 8.dp),
        shape = RoundedCornerShape(6.dp),
        modifier = modifier.width(IntrinsicSize.Min)
    ) {
        Column {
            ColorPicker(
                modifier = Modifier.padding(8.dp),
                title = "Color",
                selectedColor = color,
                onColorSelected = onColorSelected,
            )
            if (editorMode == Mode.Text || selectedObject is Label) {
                LabelTextEditor(
                    text = labelText,
                    onTextChanged = onLabelTextChanged,
                    updateWhileTyping = editorMode == Mode.Text && selectedObject !is Label,
                    modifier = Modifier.padding(8.dp).fillMaxWidth(),
                )
            }
            if (editorMode == Mode.Track || editorMode == Mode.Area || selectedObject is Track || selectedObject is Area) {
                LineThicknessPicker(
                    modifier = Modifier.padding(8.dp),
                    title = "Stroke Width",
                    sizes = listOf(1, 3, 6),
                    selectedSize = lineThickness,
                    onSizeSelected = onLineThicknessSelected,
                )
                LineStylePicker(
                    modifier = Modifier.padding(8.dp),
                    title = "Stroke Style",
                    selectedStyle = lineStyle,
                    onStyleSelected = onLineStyleSelected,
                )
            }

            if (selectedObject != null) {
                Button(
                    onClick = onRemoveSelectedObject,
                    shape = RoundedCornerShape(8.dp),
                    modifier = Modifier.padding(8.dp).height(36.dp),
                    contentPadding = PaddingValues(8.dp)
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            imageVector = Icons.Delete,
                            contentDescription = "Delete",
                            modifier = Modifier.size(16.dp)
                        )
                        Spacer(modifier = Modifier.width(8.dp))
                        Text(
                            text = "Delete",
                            style = MaterialTheme.typography.bodySmall,
                        )
                    }
                }
            }
        }
    }
}